import PointLayer from "./PointLayer";

export default class RevenueLayer extends PointLayer {
    constructor(map, data, options = {}) {
        super(map, data, 'Revenue', options = {scale: 0.2});
        this.mapTooltip = null;
    }

    handlerNode(node, info) {
        node.s({
            'interactive': false,
            '2d.selectable': false,
            '3d.selectable': false,
        });
        let seriesData = [];
        for(let i = 0; i < 5; i++) {
            seriesData.push(20 + 5 * i + Math.random() * 15);
        }
        node.a({
            axisData: [2016, 2017, 2018, 2019, 2020],
            seriesData: seriesData
        });
        node.setDataBindings({
            "a": {
                "name": {
                    "id": "$yy3d_yye_name"
                },
            }
        });
    }

    showLayer() {
        super.show();
    }

    hideLayer() {
        super.hide();
    }
}